import type { ProjectVideo } from "../types";
import { getYouTubeEmbedUrl } from "../lib/utils";

/**
 * Shared player for both the About section and project detail pages.
 *
 * The frame is a fixed 16:9 box so YouTube embeds and self-hosted MP4s line up
 * on a grid -- previously the iframe was forced to aspect-video while the
 * native <video> sized to its own intrinsic ratio, so rows never matched.
 */
export default function VideoPlayer({ video }: { video: ProjectVideo }) {
  const embed = getYouTubeEmbedUrl(video.url);

  return (
    <figure>
      <div className="aspect-video w-full overflow-hidden border border-border bg-foreground">
        {embed ? (
          <iframe
            src={embed}
            title={video.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope"
            allowFullScreen
            className="h-full w-full"
          />
        ) : (
          <video
            src={video.url}
            poster={video.poster || undefined}
            controls
            preload="none"
            className="h-full w-full"
          />
        )}
      </div>

      <figcaption className="mt-5">
        <h4 className="text-h3 font-semibold">{video.title}</h4>
        {video.description && (
          <p className="mt-2 text-muted-foreground">{video.description}</p>
        )}
      </figcaption>
    </figure>
  );
}
